import { CDN_HOST } from '../config';

export default (filePath) => `${CDN_HOST}${filePath}`;
